import type { PropsWithChildren, ReactNode } from 'react';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import Sidebar from '@rio-cloud/rio-uikit/Sidebar';
import useClickOutside from '@rio-cloud/rio-uikit/useClickOutside';
import { isMobile, isMobileScreen, SCREEN_SM } from '@rio-cloud/rio-uikit/DeviceUtils';

import { useUikitContext } from '../UikitContext';

const SIDEBAR_WIDTH = 270;

type UikitMenuSidebarProps = {
    title: string | ReactNode;
};

export const UikitMenuSidebar = (props: PropsWithChildren<UikitMenuSidebarProps>) => {
    const { title, children } = props;
    const { onMenuOutsideClicked, showMenu } = useUikitContext();
    const isMobileOrSmallScreen = isMobile() || isMobileScreen();
    const ref = useClickOutside(event => isMobileOrSmallScreen && onMenuOutsideClicked(event));

    return (
        <ApplicationLayout.Sidebar className='uikit-frame-menu'>
            <Sidebar
                title={title}
                titleClassName='padding-left-10'
                width={SIDEBAR_WIDTH}
                disableClose
                closed={!showMenu}
                hasSmoothScrollbar
                switchModeBreakpoint={SCREEN_SM}
                position={Sidebar.LEFT}
            >
                <div ref={ref}>{children}</div>
            </Sidebar>
        </ApplicationLayout.Sidebar>
    );
};
